import { useCallback, useEffect, useState } from "react";

/** Keyboard / gamepad-style nav for Gen1 menus (Up/Down/A/B + W/S/Enter/Escape). */
export function useGen1Nav(itemCount: number, onA: (index: number) => void, onB: () => void) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex((i) => (itemCount <= 0 ? 0 : Math.min(i, itemCount - 1)));
  }, [itemCount]);

  const onKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (itemCount <= 0) return;
      const code = e.code;
      if (code === "ArrowUp" || code === "KeyW") {
        e.preventDefault();
        setIndex((i) => (i <= 0 ? itemCount - 1 : i - 1));
      } else if (code === "ArrowDown" || code === "KeyS") {
        e.preventDefault();
        setIndex((i) => (i >= itemCount - 1 ? 0 : i + 1));
      } else if (code === "Enter" || code === "Numpad0" || code === "KeyZ" || code === "Space") {
        e.preventDefault();
        onA(index);
      } else if (code === "Escape" || code === "Backspace" || code === "NumpadDecimal" || code === "KeyX") {
        e.preventDefault();
        onB();
      }
    },
    [itemCount, index, onA, onB],
  );

  useEffect(() => {
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onKeyDown]);

  return { index, setIndex };
}
